import { combineReducers } from 'redux'
import auth from '../admin/modules/Authintication/store/reducer'
import common from '../admin/modules/Common/store/reducer'
import dashboard from '../admin/modules/Dashboard/store/reducer'
import website from '../admin/modules/Website/store/reducer'

export default combineReducers({ auth, common, dashboard, website })
